var reallyInsert = function () {
	var insert = true
	if (parseInt(layData.navigation_transition_out_duration, 10) == 0) {
		insert = false
	}
	if (layData.navigation_transition_out == 'none') {
		insert = false
	}
	if (layData.navigation_transition_in != 'none') {
		if (parseInt(layData.navigation_transition_in_duration, 10) != 0) {
			insert = true
		}
	}
	return insert
}

// this is just for the animations of the elements, not of the project overlay itself
var insertWrapHideStyleSheetForProjectOverlay = function () {
	if (reallyInsert()) {
		var css = document.getElementById('lay-hide-wrap-for-projectoverlay-css')

		if (!css) {
			var style = document.createElement('style')
			document.getElementsByTagName('head')[0].appendChild(style)
			style.id = 'lay-hide-wrap-for-projectoverlay-css'
			// because we need to wait for masonry to initalize before starting animation.
			// and because elements need to be hidden first, then revealed. otherwise we would have a flash of text for example

			// cant just use #lay-project-overlay{opacity: 0;}, because then the bg color of the overlay wouldnt be visible. (for when "open overlay when" -> "when loaded" setting is active)
			// so instead i use selectors inside #lay-project-overlay>.lay-content like: '#lay-project-overlay .cover-inner{opacity: 0;} #lay-project-overlay .grid-inner{opacity: 0;} #lay-project-overlay #footer{opacity: 0;}'

			// note: in doTransitionIn and window.laytheme.on('transition_out functions, we need to use the same selectors as here, so the transition in works correctly!

			// todo: what is this for?
			/*
                #lay-project-overlay>.lay-content .col.type-thumbnailgrid .thumbnail-wrap{opacity: 0;}
                #lay-project-overlay>.lay-content .col.type-elementgrid .element-wrap{opacity: 0;}
        */

			if (layData.navigation_transition_in == 'fade') {
				style.appendChild(document.createTextNode('#lay-project-overlay .grid-inner{opacity: 0;}'))
			} else {
				style.appendChild(
					document.createTextNode('#lay-project-overlay .grid-inner{opacity: 0;}' + '#lay-project-overlay .col{opacity: 0;}' + '#lay-project-overlay .col.type-thumbnailgrid:not(.no-animation):not(.no-animate-in-on-scroll) .thumbnail-wrap{opacity: 0;}' + '#lay-project-overlay .col.type-elementgrid:not(.no-animation):not(.no-animate-in-on-scroll) .element-wrap{opacity: 0;}')
				)
			}
		}
	}
}

var insertWrapHideStyleSheetForPageOverlay = function () {
	if (reallyInsert()) {
		var css = document.getElementById('lay-hide-wrap-for-pageoverlay-css')

		if (!css) {
			var style = document.createElement('style')
			document.getElementsByTagName('head')[0].appendChild(style)
			style.id = 'lay-hide-wrap-for-pageoverlay-css'
			if (layData.navigation_transition_in == 'fade') {
				style.appendChild(document.createTextNode('#lay-overlays .grid-inner{opacity: 0;}'))
			} else {
				style.appendChild(document.createTextNode('#lay-overlays .grid-inner{opacity: 0;}' + '#lay-overlays .col{opacity: 0;}' + '#lay-overlays .col.type-thumbnailgrid:not(.no-animation):not(.no-animate-in-on-scroll) .thumbnail-wrap{opacity: 0;}' + '#lay-overlays .col.type-elementgrid:not(.no-animation):not(.no-animate-in-on-scroll) .element-wrap{opacity: 0;}'))
			}
		}
	}
}

var insertWrapHideStyleSheet = function () {
	if (reallyInsert()) {
		// usually we wouldnt need to call this function here
		// but in this case, it doesnt even get called in transition out function
		// cause the call of transition out function is circumvented in history_controller
		var css = document.getElementById('lay-hide-wrap-css')
		if (!css) {
			var normalPageContentSelector = 'html:not(.scrollslider-active):not(.infinite-scrollslider-active) body>.lay-content:not(.scrollslider-active):not(.infinite-scrollslider-active)'
			var style = document.createElement('style')
			document.getElementsByTagName('head')[0].appendChild(style)
			style.id = 'lay-hide-wrap-css'
			if (layData.navigation_transition_in == 'fade') {
				style.appendChild(document.createTextNode(normalPageContentSelector + '{opacity: 0;}'))
			} else {
				style.appendChild(document.createTextNode(normalPageContentSelector + '{opacity: 0;}' + normalPageContentSelector + ' .col{opacity: 0;}' + normalPageContentSelector + ' .col.type-thumbnailgrid:not(.no-animation):not(.no-animate-in-on-scroll) .thumbnail-wrap{opacity: 0;}' + normalPageContentSelector + ' .col.type-elementgrid:not(.no-animation):not(.no-animate-in-on-scroll) .element-wrap{opacity: 0;}'))
			}
		}
	}
}

export { insertWrapHideStyleSheetForProjectOverlay, insertWrapHideStyleSheetForPageOverlay, insertWrapHideStyleSheet }
